import Item from './item';
import ToggleButtonInternal from './toggle-button-internal';
const ToggleButtonNamespace = Object.assign(ToggleButtonInternal, {
    Item,
});
export default ToggleButtonNamespace;
